import React, {useEffect, useRef, useState} from "react";
import store from './Stores/SurveyStore';
import ibsStore from './Stores/IbsSurveyStore';
import {
    toNumber
} from '../helpers'
import { observer } from "mobx-react";
import $ from 'jquery';
import {NumberFormat} from '../Enums/constants';
import {HotTable} from '@handsontable/react';
import 'handsontable/dist/handsontable.full.css';
import {saveValueNew, insertRowCtrl} from '../control'
import {
    sumOfInternalTeamsNAV,
} from "../ibsHelper";
import { calculationsForProvided } from "../Helpers/TableCalculationHelper";
import { getHiddenColumns, getHiddenRows, isNumField, manageContainerWidth, getTableHeaders, getMergedCells, isCellNA, renderDeleteIconBtn, renderEditIconBtn, renderOptionEditIconBtn, renderOptionIconsBtn, editOptionRow, setPlaceHolderCell, loadDefaultTableErrors, deleteRow } from "../Helpers/TableHelper";
import { errorTooltipCreator } from "../Helpers/TableTooltipCreator";
import { exportData } from "../Helpers/ExportTableDataHelper";
import { formatNumber } from "../Helpers/General/FormatHelper";


var classNames = require('classnames');

const SurveyCondensedTable = observer((props) => {
    const hotTableInstance = useRef(null);

    var referenceToTable = []
    var dataObj = [];
    var listOfHeaderRows = [];
    var listOfErrorWarning = [];


    let stickyHeaderTableIds = ['AssetAllocation', 'combinedAssets', 'Benchmark', 'mandate', 'Options', "PrivateEquity"];

    let [invalidCells, setInvalidCells] = useState({});

    let updateAssetSearchBox = (updateText) => {
        $('#searchInput1').val(updateText);
    }

    useEffect(() => {
        updateAssetSearchBox((typeof ibsStore.assetSearchToRender !== "string") ? "" : ibsStore.assetSearchToRender);
    });

    let rowJustAdded;
    
    const handleHOTChange = (table, rowNum, qId, oldValue, newValue) => {
        if (props.handleHOTChange) {
            props.handleHOTChange(table, rowNum, qId, oldValue, newValue, props, referenceToTable)
        } else {
            handleHOTChangeDefault(table, rowNum, qId, oldValue, newValue)
        }
        
    };
    const renderTotalRow = () => {
        let totRow = {};
        if (props.renderTotalRow) {
            totRow = props.renderTotalRow(props)
            return totRow
        }
        return totRow
    }

    const handleData = () => {
        let data
        if (props.handleData) {
            //has its own data builder, see the table file for more details
            data = props.handleData(props, referenceToTable, listOfHeaderRows, dataObj)
            rowJustAdded = referenceToTable.findIndex((element) => element.RowID === ibsStore.lastRowAdded)
            loadTableErrors(props.tableName);
        } else {
            data = handleDefaultData(props, referenceToTable, listOfHeaderRows, dataObj)
            referenceToTable = data[1]
            listOfHeaderRows = data[2]
        }

        // Handsontables does not like empty array as an input, so verify input is a non empty array 
        if (data && Array.isArray(data[0]) && data[0].length > 0) {
            referenceToTable = data[1]
            listOfHeaderRows = data[2]
            return data[0]
        }

        // Handsontables initialization check passes if you pass in any array containing an object
        // It's implied this should be an array containing an empty array in the handsontable documentation but I live in fear so it will remain
        return [{}];

    };
    const handleHOTChangeDefault = (table, rowNum, qId, oldValue, newValue) => {
        if (rowNum !== undefined && rowNum !== null
            && qId !== undefined && qId !== null
            && newValue != oldValue
            && newValue !== 'undefined') { // TODO something weird happens when this is changed to newValue !== oldValue

            let normalizedNewValue = newValue;

            if (isNumField(table, qId, props)) {
                normalizedNewValue = toNumber(newValue);
                if (Number.isNaN(normalizedNewValue)) {
                    // It's a number field, but newValue is not a number
                    // just save an empty value
                    normalizedNewValue = null;
                }
            }
          
            let rowId, result;
            rowId = referenceToTable[rowNum].RowID //the rowId 
            result = ibsStore.allTableResponses[props.tableName].findIndex(row => row.RowID === rowId); //where it is saved on frontend

            ibsStore.allTableResponses[props.tableName][result][qId] = normalizedNewValue;

            let rulesSet = saveValueNew(qId, normalizedNewValue, { tableName: props.tableName, rowId })

        }
    }

    let lastEncounteredAssetCat = undefined;

    //special DB Asset Renderers
    const categoryRowRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        let cellFormat = undefined;
        if (props.formatting && props.formatting[col]) cellFormat = props.formatting[col];
        if (cellFormat && (value || value === 0) && !isNaN(value)) {
            value = formatNumber(cellFormat, toNumber(value))
            td.style.textAlign = "right"
        }


        td.innerHTML = value
        td.className = td.className + " categoryRow"
        var backgroundColor = '#f9f9f9';
        cellProperties.readOnly = true

        // Text is bolded for catetory rows not in AssetClassCategoryName
        // We should specify a list of tables for this apply to
        if (prop === "AssetClassCategoryName" && value !== "") {
            lastEncounteredAssetCat = value
        }
        //td.style.backgroundColor = backgroundColor;
        td.style.setProperty("background-color", backgroundColor, "important");
    }
 
    let lastEncounteredImplStyle = undefined;

    //I'm not too sure where this is used, probably from assets but it wasnt moved over to that file...
    let assetColumnMapping = {
        "FeesPaidHoldingsMillions": "NotionalAmount",
        "InternalCosts": "CostThousands"
    }

    //move this error renderer out
    const errorRenderer = (td, row, column, prop, value, cellProperties) => {
        if (!referenceToTable) return
        if (!referenceToTable[row]) {
            return;
        }

        var currentRowID = referenceToTable[row].RowID;
        //MOVE THIS
        if ((props.tableName == "Options" || props.tableName == "TDBalancedFunds")) {
            currentRowID = referenceToTable[row].OptionID;
        }

        if (typeof currentRowID === "undefined" || currentRowID === null) {
            return;
        }

        // translatedProp allows props to effectively masquerade as a different prop for rendering errors
        var warningErrorIndexes = [];
        let translatedProp = null;
        if (currentRowID == "Total") {
            translatedProp = typeof assetColumnMapping[prop] === 'undefined' ? prop : assetColumnMapping[prop]

        }
        else {
            translatedProp = typeof assetColumnMapping[prop] === 'undefined' ? null : assetColumnMapping[prop];
        }
        //MOVE THIS
        if (props.tableName == "Options" && translatedProp === null) {
            if (prop === "AssetClassName") {
                translatedProp = "AssetClassID";
            }
            if (prop === "MandateStyleName") {
                translatedProp = "StyleID";
            }
        }

        // translatedProp error resolver
        var warningErrorIndex = -1;
        if (translatedProp != null) {
            if (currentRowID == "Total") {
                warningErrorIndex = listOfErrorWarning.findIndex(function (v, i) {
                    return ((v["errorTotalCol"] != null && v["errorTotalCol"].toLowerCase() == translatedProp.toLowerCase()));
                })
            }
            else {
                warningErrorIndex = listOfErrorWarning.findIndex(function (v, i) {
                    return ((v["qName"].toLowerCase() == translatedProp.toLowerCase() && v["rowID"] == currentRowID));

                })
            }
            if (warningErrorIndex != -1) {
                warningErrorIndexes.push([translatedProp, warningErrorIndex]);
            }
        }

        warningErrorIndex = listOfErrorWarning.findIndex(function (v, i) {
            let costsThousandsCondition = false;
            if (prop === "InternalCosts") {
                if (v["qName"].toLowerCase() === "internalmonitoringcost" && v["rowID"] === currentRowID) {
                    costsThousandsCondition = true;
                }
            }

            return ((v["qName"].toLowerCase() === prop.toLowerCase() && v["rowID"] === currentRowID) || costsThousandsCondition);
        })
        if (warningErrorIndex != -1) {
            warningErrorIndexes.push([prop, warningErrorIndex]);
        }
       
        //render error/warning tooltips on table
        if (warningErrorIndexes.length > 0) {
            errorTooltipCreator(td, props, value, warningErrorIndex, warningErrorIndexes, listOfErrorWarning, currentRowID)

        }

    }
    const cellRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        if (props.cellRenderer) {
            cellProperties = defaultCellRenderer(instance, td, row, col, prop, value, cellProperties)
            props.cellRenderer(instance, td, row, col, prop, value, cellProperties, referenceToTable, props, listOfHeaderRows)
        } else {
            defaultCellRenderer(instance, td, row, col, prop, value, cellProperties)
        }
    }

    const defaultCellRenderer = (instance, td, row, col, prop, value, cellProperties) => {
       
        if (props.tableName && referenceToTable) {

            let cellFormat = undefined;

            if (props.formatting && props.formatting[col]) cellFormat = props.formatting[col];

            const isNumField = Object.values(NumberFormat).indexOf(cellFormat) > -1;
            let spawnNumberError = false;

            // Pass in styleID instead of styleName to improve the checks in isCellNA 
            if (isCellNA(row, col, props, referenceToTable, lastEncounteredImplStyle, lastEncounteredAssetCat)) {
                value = "N/A"
                td.className = td.className + " cellNA"
                td.style.textAlign = "right !important"
                cellProperties.readOnly = true
            } else {
                td.className = td.className + " regCell"


            }

            //LETS MOVE THIS
            
            if (value === undefined || value === null || value === "") {
                value = "";
            } else {
                td.style.border = "1px solid #e2e2e2"
            }
            if (referenceToTable[row]) var currentRowID = referenceToTable[row].RowID

            if (typeof currentRowID === 'undefined') {
                var flag = 0;
                flag++;
            }

            td.id = currentRowID

            if (isNumField && value !== null && value !== '' && value !== 'N/A') {
                let parsedValue = toNumber(value);
                if (Number.isNaN(parsedValue)) {
                    spawnNumberError = true;
                }
            }

            if (cellFormat && (value || value === 0) && value !== "N/A") {
                value = formatNumber(cellFormat, toNumber(value))
                td.style.textAlign = "right"

            }
          

            //set any placeholders for cell
            let returned = setPlaceHolderCell(props, td, value, col)
            td = returned[0]
            value = returned[1]

            td.innerHTML = value;

            //show question names when the question mode is enabled
            if (store.questionMode) {
                td.innerHTML = prop
            }

            if (col == props.headers.length - 1) {
                let lastColHeader = props.headers[col];
                let lastColHeaderLabel = typeof (lastColHeader) === 'string' ? lastColHeader : lastColHeader.label;
                if (lastColHeaderLabel.trim() === '' || lastColHeaderLabel.trim() === 'del') {
                    td.className = td.className + " delCol"
                }
            }
            //MOVE THIS
            switch (props.tableName) {
                case "AssetAllocation":
                    if ((col === 4) || (col === 1)) {
                        td.className = td.className + " readOnlyCell"
                        td.className = td.className + " noBorder"
                        td.style.border = "0px solid #e2e2e2"
                    }
                    break;

            }
            //currently unstable it seems
            if (spawnNumberError) {
                /* Init error, false indicates error has not been shown for 5 seconds */
                if (!invalidCells[props.tableName]) invalidCells[props.tableName] = {};
                if (!invalidCells[props.tableName][currentRowID]) invalidCells[props.tableName][currentRowID] = {};

                if (invalidCells[props.tableName][currentRowID][col]) {
                    td.className = td.className + " tooltipCustom error"
                    let span = document.createElement("span")
                    span.className = "genericTooltip tooltiptext small"
                    span.innerHTML = "Please enter a number";
                    td.appendChild(span);
                } else {
                    td.className = td.className + " tooltipCustom error"
                    let span = document.createElement("span")
                    span.className = "genericTooltip tooltiptext small visible"
                    span.innerHTML = "Please enter a number";
                    setTimeout((span) => {
                        span.className = "genericTooltip tooltiptext small";
                        invalidCells[props.tableName][currentRowID][col] = true;
                    }, 5000, span);
                    td.appendChild(span);
                }
            }
            //add a highlight if row was just added
            if (row === rowJustAdded && prop !== "del") {
                td.className = td.className + " highlightTableRow"

            }
            //handle icons at the end of the row
            if (listOfHeaderRows.includes(row)) {
                td.className = td.innerHTML = "";
                td.className = td.className + "delColHeaderRow"
            }
            
            if (prop === "del" && !listOfHeaderRows.includes(row) && !props.cellRenderer) {
                //&& td.id !== "undefined"
                renderDeleteIconBtn(td, row, props, referenceToTable)
             

            }
        }
        return cellProperties
    }


    const loadTableErrors = () => {
        if (props.loadTableErrors) {
            listOfErrorWarning = props.loadTableErrors()
        } else {
            listOfErrorWarning = loadDefaultTableErrors(listOfErrorWarning)
        }

    };
   
    const isTableEmpty = () => {

        if (ibsStore?.allTableResponses && props.tableName && ibsStore.allTableResponses[props.tableName]) {
            var rawData = ibsStore.allTableResponses[props.tableName]
            if (typeof rawData === "undefined" || rawData === null || (Array.isArray(rawData) && rawData?.length === 0)) {
                return true;
            }
        }
 
        return false;
    }
    
    //Data handler (check if its DB assets table or not)
    const handleDefaultData = () => {
        // hope this only will not get retriggered when we update the overriden stuff
        // need to overwrite this to keep things correct
        store.overridenWarnings = {};
        store.overridenErrors = {};
        //compile list of errors
        loadTableErrors(props.tableName);
        
        let includeTotalRow = props.includeTotalRow;
        
        if (ibsStore.allTableResponses) {
            var rawData = ibsStore.allTableResponses[props.tableName]

            if (isTableEmpty()) rawData = [{}];
            referenceToTable = rawData;
            rawData = calculationsForProvided(rawData, props);
            let dataObj = rawData;
            
            if (dataObj) dataObj = dataObj.slice();
            else dataObj = [];

            //remove this from here!!!
            if (includeTotalRow) {

                let totalRow = {};
                totalRow = renderTotalRow();
                if (Object.keys(totalRow).length > 0) {
                    dataObj.push(totalRow);
                    listOfHeaderRows.push(dataObj.length - 1);
                }
            }
            return [dataObj, referenceToTable, listOfHeaderRows];
        }
   
    }

    /* Fixed Header */
    let isScrolledPastHeader = false;

    function isScrolledPast(el, table, offset = 0) {
        var headerRect = el.getBoundingClientRect();
        var tableRect = table.getBoundingClientRect();
        var headerTop = headerRect.top;
        var headerBottom = headerRect.bottom;
        var tableBottom = tableRect.bottom;

        /* Return true if element is above the top offset and below the window bottom */
        var isVisible = (headerTop <= offset) && (headerBottom <= window.innerHeight) && (tableBottom >= (offset + (headerBottom - headerTop)));

        return isVisible;
    }

    
   
    /* Scroll listener for fixed header */
    useEffect(() => {
        const handleScroll = () => {
            if (stickyHeaderTableIds.indexOf(props.tableName) > -1 && store.currentLandedPage !== "print") {
                /*
                    Hot table renders two headers, the original one attached to the
                    table which is hidden, and a duplicate which is displayed.

                    Track the original headers position, and if it is off screen,
                    stick the duplicate to just below the navbar
                */
                let origTable = document.querySelector(".ht_master.handsontable");
                let origTableHeader = document.querySelector(".ht_master.handsontable thead");
                let navBarDiv = document.querySelector("div.fixed-top");
                let navBar = document.querySelector("div.fixed-top > nav.navbar");

                if (origTableHeader && navBarDiv && navBar) {
                    /* Navbar height is off when in mobile mode so check both outer and inner nav elements */
                    let actualNavHeight = Math.max(navBarDiv.clientHeight, navBar.clientHeight);
                    let updatedIsScrolledPast = isScrolledPast(origTableHeader, origTable, actualNavHeight);
                    let dupHeader = document.querySelector(".ht_clone_top.handsontable");

                    if (updatedIsScrolledPast != isScrolledPastHeader) {
                        if (updatedIsScrolledPast) {
                            dupHeader.classList.add('stuck');
                            dupHeader.style.position = 'fixed';
                            dupHeader.style.top = `${actualNavHeight}px`;
                            dupHeader.style.removeProperty('left');
                        } else {
                            dupHeader.classList.remove('stuck');
                            dupHeader.style.position = 'absolute';
                            dupHeader.style.top = `0`;
                            dupHeader.style.left = `0`;
                        }
                        isScrolledPastHeader = updatedIsScrolledPast;
                    }

                    if (dupHeader.classList.contains('stuck')) {
                        /* Double check height compared to navbar */
                        let offsetY = dupHeader.style.top;
                        if (`${actualNavHeight}px` != offsetY) {
                            dupHeader.style.top = `${actualNavHeight}px`;
                        }

                        /* Set the left based on the scroll */
                        var leftLen = origTableHeader.getBoundingClientRect().left;
                        dupHeader.style.left = `${leftLen}px`;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => window.removeEventListener("scroll", handleScroll);
    }, [isScrolledPastHeader]);

    /* Resize listener for fixed header */
    useEffect(() => {
        const handleResize = () => {
            /* On resize, compare to navbar as the navbar height may change between desktop/mobile */
            let dupHeader = document.querySelector(".ht_clone_top.handsontable");
            let navBarDiv = document.querySelector("div.fixed-top");
            let navBar = document.querySelector("div.fixed-top > nav.navbar");

            let actualNavHeight = Math.max(navBarDiv.clientHeight, navBar.clientHeight);

            if (dupHeader.classList.contains('stuck')) {
                let offset = dupHeader.style.top;
                if (`${actualNavHeight}px` != offset) {
                    dupHeader.style.top = `${actualNavHeight}px`;
                }
            }
        }

        window.addEventListener("resize", handleResize, { passive: true });

        return () => window.removeEventListener("resize", handleResize);
    });
    const defaultCells = (row, col, prop) => {
        var cellProperties = {};
        var lastRow;
        if (ibsStore.allTableResponses["Options"]) {
            lastRow = ibsStore.allTableResponses["Options"].length + dataObj.length - 1;
        }

        //If it a category Row, special formatting
        var delCol = props.headers.findIndex((element) => element === "del");
        var actionCol = props.headers.findIndex((element) => element === "action");
        var totalCol = props.headers.findIndex((element) => element === "totalRowCost");
        var totalCol2 = props.headers.findIndex((element) => element === "TotalExpenseRatio");
        var totalCol3 = props.headers.findIndex((element) => element === "Total");
        var totalCol4 = props.headers.findIndex((element) => element === "TotalPercent");

        if (listOfHeaderRows && listOfHeaderRows.includes(row) && (col != delCol && col != actionCol)) {
            // TODO: Ensure that dataObj.length is set correctly before adding this line back to the previous if statement
            cellProperties.renderer = categoryRowRenderer
            cellProperties.readOnly = true;

        } else if (props.tableName == "FrontOffice" && prop == "NAV" && referenceToTable[row]?.RowID) {
            let internalTeamID = referenceToTable[row]?.RowID
            let sumNAV = sumOfInternalTeamsNAV(internalTeamID);
            cellProperties.renderer = (instance, td, row, col, prop, value, cellProperties) => {
                td.innerHTML = formatNumber(NumberFormat.MONEYMILLION, sumNAV)
                cellProperties.readOnly = true;
                td.className = "readOnlyCell htRight";
            };
        }

        //make the delete column read only
        if (col === delCol || col === actionCol) {
            cellProperties.readOnly = true;
        }
        // TODO: Describe cases where total column should be rendered as category row (totalCol3)
        if ((col === totalCol ||
            col === totalCol2 ||
            (col === totalCol3 && false) ||
            col === totalCol4)
            && !listOfHeaderRows.includes(row)) { cellProperties.renderer = categoryRowRenderer }

        return cellProperties;
    }
    const openNewOptionModal=() => {
        ibsStore.showOptionRowModal = true;
    }
    const cells = (row, col, prop) => {
        let cellProps = defaultCells(row, col, prop)
        //any necessary overrides in for cells
        if (props.cells) cellProps = props.cells(cellProps, row, col, prop, props, referenceToTable, listOfHeaderRows)
        return cellProps
    }

    const addEmptyRow=(props)=> {
        if (props.addEmptyRow) {
            props.addEmptyRow()
        }
        else {
            insertRowCtrl("", "", props.tableName)
        }

    }
    return (
        <React.Fragment>
            <div style={props.styleOverride} className={classNames(props.tableName, "fade-in")}>
                <React.Fragment>
                    {props.tableName == "Options" &&
                        <div className="own-row">
                            <button type="button" onClick={e => openNewOptionModal()} disabled={!store.userCanEditReadOnlySurvey} className="btn btn-add-row">Add Option</button>
                        </div>
                    }

                    {!props.addRowBtnName || props.noButton &&
                        <div className="own-row">
                            <button type="button" onClick={e => addEmptyRow(props)} className="btn btn-add-row">Add New Row</button>
                        </div>
                    }
                    {(props.addRowBtnName || props.canDownload) &&
                        <div className="own-row">
                            {props.addRowBtnName &&
                                <button type="button" onClick={e => addEmptyRow(props)} disabled={!store.userCanEditReadOnlySurvey} className="btn btn-add-row">{props.addRowBtnName}</button>
                            }
                            {props.canDownload &&
                                <i class="fa fa-download fa-2x downloadButton" style={{ marginLeft: '10px', marginTop: '20px' }} aria-hidden="true" title="d Data" onClick={e => exportData(hotTableInstance, referenceToTable, props)}></i>
                            }
                        </div>
                    }
                    {props.tableName === "ValidationTable" &&
                        <div>
                            <div>
                                <span className="sectionTitle">Your Cost Summary</span>
                                <i class="fa fa-download fa-2x downloadButton" style={{ marginLeft: '10px' }} aria-hidden="true" title="Export Data" onClick={e => exportData(hotTableInstance, referenceToTable, props)}></i>
                            </div>
                            <div className="errors-desc">The imputed costs applied in the survey are only shown where fees are missing. The actual imputations applied throughout your report may differ from the above in certain circumstances, e.g., in cases where a fee is provided, but fails a reasonableness check and is lacking supporting supplemental detail, a imputed cost may be applied.<br /> <br />
                                Private asset costs may also differ in your report if you provide additional Limited Partnership (LP) details. If completed, we will use the information from your supplemental LP details to 'override' the provided costs to estimate your gross private asset fees.</div>
                            <br />
                        </div>
                    }

                </React.Fragment>
                <div className="surveyCondensedTableContainer">
                    <HotTable root="hot" data={handleData()}
                        renderAllRows={store.currentLandedPage === "print"}
                        nestedHeaders={getTableHeaders(true,props)}
                        rowHeights={25} 
                        ref={hotTableInstance}
                        fixedColumnsLeft={props.fixedCols}
                        columnHeaderHeight={[25, undefined]}
                        className={props.tableName == "TDBalancedFunds" ? "hotOverride" : null}
                        afterChange={function (changes, source) {
                            if(changes === null) {
                                // Set new nested headers with correct placeholders
                                if (props.nestedHeaders) {
                                
                                }
                            } else {
                                const rowNum = changes[0][0];
                                const propQId = changes[0][1];
                                const oldVal = changes[0][2];
                                const newVal = changes[0][3];

                                //exceptions
                                
                                //send rowId, questionID, and new value
                                handleHOTChange(this, rowNum, propQId, oldVal, newVal);
                                if (typeof rowJustAdded !== "undefined" && rowJustAdded !== null && rowNum === rowJustAdded) {
                                    ibsStore.lastRowAdded = null;
                                }
                            }
                        }} 
                        deselect={function () {

                        }}
                        renderer={cellRenderer}
                        dragToScroll={false}
                        afterRenderer={function (td, row, column, prop, value, cellProperties) {
                            errorRenderer(td, row, column, prop, value, cellProperties);
                           
                        }}
                        cells={function (row, col, prop) {
                            return cells(row, col, prop)
                        }}
                        mergeCells={getMergedCells(props, listOfHeaderRows)}
                        columns={props.columns}
                        nestedRows={true}
                        hiddenColumns={{ columns: getHiddenColumns(props) }}
                        hiddenRows={{ rows: getHiddenRows(props, referenceToTable) }}
                        startRows={0}
                        trimDropdown={props.trimDropdown}
                        wordWrap={false}
                        readOnly={!store.userCanEditReadOnlySurvey || store.questionMode || isTableEmpty()}
                        disableVisualSelection={!store.userCanEditReadOnlySurvey || store.questionMode || isTableEmpty() }
                        manualColumnResize={ !isTableEmpty() }
                        manualRowResize={ !isTableEmpty() }
                        afterOnCellMouseDown={function (e, coords, TD) {
                            //last column in table is the delete button
                            var delCol = props.headers.findIndex((element) => element === "del");
                            if (coords.col === delCol && !listOfHeaderRows.includes(coords.row)) {
                                if (TD.innerHTML.includes("del-row-icon")) deleteRow(coords.row)
                            }

                            if (props.tableName === "Options" && TD?.className?.includes("readOnlyCell")) {
                                var now = new Date().getTime();
                                if (!(TD.lastClick && now - TD.lastClick < 500)) {
                                    TD.lastClick = now;
                                }
                                else {
                                    let optId = referenceToTable[coords?.row]?.OptionID;
                                    if (typeof optId !== "undefined" && optId !== null) {
                                        editOptionRow(optId);
                                    }
                                }
                            }
                        }}
                        licenseKey={'f9ac8-f01c1-70bd1-f4c2a-0e43c'}
                        handleHotBeforeOnCellMouseDown={function (event, coords, element) {
                            //idk
                            if (coords.col === 14 && coords.row != -1 && coords.row != -2) {
                                event.stopImmediatePropagation();
                            }
                          
                        }}
                        beforeOnCellMouseDown={function (e, coords) {
                            var value = e.target.innerText;
                            if (props.headers[coords["col"]]=='del') {
                                e.stopImmediatePropagation()
                            }
                        }
  	                    }
                        beforeKeyDown={function (e) {
                            if (props.beforeKeyDown) {
                                props.beforeKeyDown(e, this.getActiveEditor())
                            }
                        }}

                        beforeChange={function (changes, source) {

                            if (changes == null) {
                                return;
                            }

                            if (props.tableName === "PrivateEquity" && changes[0][1] === "DataYear") {
                                /* revert changes to PrivateEquity DataYear if column does not have 4 digits for a year */
                                if (changes[0][3].length !== 4 && changes[0][3].length !== 0) {
                                    changes[0][3] = changes[0][2];
                                }
                            }

                            const propQId = changes[0][1];
                            if (propQId == "Constituents") {
                                changes[0][3] = "";
                            }
                            
                        }
                        }
                        afterColumnResize={(newSize, column) => {
                            manageContainerWidth(true);
                        }}
                        colWidths={props.colWidths}
                        afterRender={() => {
                            manageContainerWidth()
                            /* 
                                There seems to be a bug where on load after
                                render the hotInstance isn't available yet,
                                try again after 1 second to properly fit the
                                table
                            */
                            setTimeout(() => manageContainerWidth(), 1000);


                        }}
                        afterGetColHeader={function (col, TH) {
                            TH.classList.add('htLeft');
                        }}
                        beforePaste={(changes, src) => {
                            // If changes don't exist, don't paste
                            if (!changes || !src) {
                                return false;
                            }
                            // If changes are limited to one cell, edit cell as normal
                            if (changes.length === 1 && (changes[1]?.length ?? 1) === 1) {
                                return true;
                            }
                            /* No multi paste - Mitch */
                            return false;

                        }
                        }
                    />
                </div>

            </div>
        </React.Fragment>)
});
export default SurveyCondensedTable;


